// Angular admin integrations page, served while `enable_integrations_migration`
// is off for the company. The query shapes of the OAuth callbacks must match
// learn-app's own `/zoom` and `/slack{,-eddy}` server routes so the legacy
// zoom-settings and slack-settings directives can finish the exchange.
export const LEGACY_INTEGRATIONS_PATH = '/pvt/#/overview/settings/integrations';

// learn-app's `/zoom` route names the code param `zoomcode`; `/slack-eddy` marks
// the callback with a trailing `&type=eddy`. Param order is part of the contract.
const legacyOAuthCallbackUrl = (
  params: URLSearchParams,
  { codeParam = 'code', suffix = '' }: { codeParam?: string; suffix?: string } = {},
): string =>
  `${LEGACY_INTEGRATIONS_PATH}?${codeParam}=${encodeURIComponent(params.get('code') ?? '')}` +
  `&state=${encodeURIComponent(params.get('state') ?? '')}` +
  `&error=${encodeURIComponent(params.get('error') ?? '')}` +
  suffix;

export const legacyZoomCallbackUrl = (params: URLSearchParams): string =>
  legacyOAuthCallbackUrl(params, { codeParam: 'zoomcode' });

export const legacySlackCallbackUrl = (params: URLSearchParams, eddy: boolean): string =>
  legacyOAuthCallbackUrl(params, { suffix: eddy ? '&type=eddy' : '' });
